import React from "react";
import { SvgIconProps } from "./SvgIconProps";

const AllArticlesIcon: React.FC<SvgIconProps> = ({ color, ...props }) => (
    <svg viewBox="0 0 28 21" xmlns="http://www.w3.org/2000/svg" fillRule="evenodd" clipRule="evenodd" strokeLinejoin="round" strokeMiterlimit="2" {...props}>
        <path fill={color || "currentColor"} d="M0 0h7.741v5.513H.001zM9.731 0h7.741v5.513H9.731zM19.531 0h7.742v5.513H19.53zM0 7.495h7.741v5.513H.001zM9.731 7.495h7.741v5.513H9.731zM19.531 7.495h7.742v5.513H19.53zM0 15.007h7.741v5.513H.001zM9.731 15.007h7.741v5.513H9.731zM19.531 15.007h7.742v5.513H19.53z"/>
    </svg>
);

export default AllArticlesIcon;